// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3fLaG","bigColWidth":"Table_bigColWidth__1vb2n","biggerColWidth":"Table_biggerColWidth__1ZR2c","row":"Table_row__2cBBr","col":"Table_col__1pV7i"};